import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterDeck,
  CampaignDeck,
} from "@dndModels";
import { DisablableOption } from "@models";

import API from "@utilities/smart_api";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  char: Character;
  char_item: CharacterDeck;
  // onChange: (repopulate: boolean, close: boolean) => void;
}

const api = API.getInstance();

export default function CharacterDeckControls({
  char,
  char_item,
  // onChange,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [campaign_decks, setCampaignDecks] = useState<CampaignDeck[]>([]);
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    // debugger;
    setFetched(true);
    if (char.old_campaign_id !== "" && char_item instanceof CharacterDeck && char_item.deck_id !== "") {
      setLoading(true);
      api.getObjects({ data_type: "campaign_deck", filter: { 
        campaign_id: char.old_campaign_id, c_options: char.c_options, deck_id: char_item.deck_id }}).then(res => {
        setCampaignDecks(res as CampaignDeck[]);
        setLoading(false);
      });
    }
  }

  const enabled = api.user && (char.owner_id === api.user._id || (char.campaign && char.campaign.owner_id === api.user._id));
  
  if (!fetched || loading) {
    return (
      <Grid
        size={{
          xs: 12
        }}><LoadingBox /></Grid>
    );
  } else {
    const options = campaign_decks.map(o => {
      const opt: DisablableOption = {
        id: o._id, text: o.name
      };
      return opt;
    });
    return (
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Campaign Deck"
          options={options}
          value={char_item.campaign_deck_id}
          disabled={!enabled}
          onChange={(changed: string) => {
            if (char_item instanceof CharacterDeck) {
              char_item.campaign_deck_id = changed;
              // onChange(false, false);
              char.changed();
              char.subscription_holder.itemsChanged();
              setPing(!ping);
            }
          }}
        />
      </Grid>
    );
  }
}
